export default "__VITE_ASSET__bcb562ea__"